<template>
  <div v-if="currentOomList && currentOomList.length">
    <b-row class="Desk">
      <b-col class="mobCol">
        <div class="dataTitle">{{ currentOomTitle }}</div>
        <a
          class="playertopSizes"
          :href="'/playerprofile/' + currentOomFirst.playerno"
        >
          <b-img
            class="oomTopImg"
            :src="
              DEFIMAGESAMS3 + 'sst' + '/' + 'media/photos/' +
              currentOomFirst.playerno +
              '.jpg'
            "
          ></b-img>
        </a>
        <a
          :href="'/playerprofile/' + currentOomFirst.playerno"
          class="playerLink"
        >
          <b-row class="bottomOom">
            <b-col lg="12">
              <span class="homePos">
                <span class="innerPos">{{ currentOomList[0].pos }}</span>
              </span>
            </b-col>
            <b-col lg="12">
              <b-row>
                <b-col cols="12" lg="2" md="2" sm="2">
                  <b-img
                    class="playerFlag"
                    :src="
                      (config.VUE_APP_FLAG_URL + currentOomList[0].nationality)
                        | lowercase
                    "
                  ></b-img>
                </b-col>
                <b-col cols="12" lg="10" md="10" sm="10">
                  <span class="infoBlock">
                    <p class="topOomName">
                      {{ currentOomList[0].name }}
                    </p>
                    <p class="topOomName oomValue">
                      {{ currentOomList[0].oom_value }}
                    </p>
                    <p class="tournsPlayed">
                      <span>Tournaments: </span
                      >{{ currentOomList[0].tournaments_played }}
                    </p>
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </a>
      </b-col>
      <b-col class="mobCol">
        <template>
          <div class="dataTitle">{{ rookieTitle }}</div>
          <a
            class="playertopSizes"
            :href="'/playerprofile/' + rookieFirst.playerno"
          >
            <b-img
              class="oomTopImg"
              :src="
                DEFIMAGESAMS3 + 'sst' + '/' + 'media/photos/' +
                rookieFirst.playerno +
                '.jpg'
              "
            ></b-img>
          </a>
          <a :href="'/playerprofile/' + rookieFirst.playerno" class="playerLink">
            <b-row class="bottomOom">
              <b-col lg="12">
                <span class="homePos">
                  <span class="innerPos">{{ rookieList[0].pos }}</span>
                </span>
              </b-col>
              <b-col lg="12">
                <b-row>
                  <b-col cols="12" lg="2" md="2" sm="2">
                    <b-img
                      class="playerFlag"
                      :src="
                        (config.VUE_APP_FLAG_URL + rookieList[0].nationality)
                          | lowercase
                      "
                    ></b-img>
                  </b-col>
                  <b-col cols="12" lg="10" md="10" sm="10">
                    <span class="infoBlock">
                      <p class="topOomName">
                        {{ rookieList[0].name }}
                      </p>
                      <p class="topOomName oomValue">
                        {{ rookieList[0].oom_value }}
                      </p>
                      <p class="tournsPlayed">
                        <span>Tournaments: </span
                        >{{ rookieList[0].tournaments_played }}
                      </p>
                    </span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </a>
        </template>
      </b-col>
      <b-col class="mobCol">
        <div class="dataTitle">{{ statsTitle }}</div>
        <a
          class="playertopSizes"
          :href="'/playerprofile/' + statsFirst.playerno"
        >
          <b-img
            class="oomTopImg"
            :src="
              DEFIMAGESAMS3 + 'sst' + '/' + 'media/photos/' +
              statsFirst.playerno +
              '.jpg'
            "
          ></b-img>
        </a>
        <a :href="'/playerprofile/' + statsFirst.playerno" class="playerLink">
          <b-row class="bottomOom">
            <b-col lg="12">
              <span class="homePos">
                <span class="innerPos">{{ statsLists[0].pos }}</span>
              </span>
            </b-col>
            <b-col lg="12">
              <b-row>
                <b-col cols="12" lg="2" md="2" sm="2">
                  <b-img
                    class="playerFlag"
                    :src="
                      (config.VUE_APP_FLAG_URL + statsLists[0].nationality)
                        | lowercase
                    "
                  ></b-img>
                </b-col>
                <b-col cols="12" lg="10" md="10" sm="10">
                  <span class="infoBlock">
                    <p class="topOomName">
                      {{ statsLists[0].name }}
                    </p>
                    <p class="topOomName oomValue">
                      {{ statsLists[0].oom_value }}
                    </p>
                    <p class="tournsPlayed">
                      <span>Tournaments: </span
                      >{{ statsLists[0].tournaments_played }}
                    </p>
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </a>
      </b-col>
    </b-row>
    <b-row class="Mob">
      <b-col class="mobCol" cols="12" sm="12">
        <div class="dataTitle">{{ currentOomTitle }}</div>
        <a
          class="playertopSizes"
          :href="'/playerprofile/' + currentOomFirst.playerno"
        >
          <b-img
            class="oomTopImg"
            :src="
              DEFIMAGESAMS3 + 'sst' + '/' + 'media/photos/' +
              currentOomFirst.playerno +
              '.jpg'
            "
          ></b-img>
        </a>
        <b-row class="bottomOom">
          <b-col lg="12">
            <span class="homePos">
              <span class="innerPos">{{ currentOomList[0].pos }}</span>
            </span>
          </b-col>
          <b-col lg="12">
            <b-row>
              <b-col lg="2" md="2" sm="2" class="mobFlag">
                <b-img
                  class="playerFlag"
                  :src="
                    (config.VUE_APP_FLAG_URL + currentOomList[0].nationality)
                      | lowercase
                  "
                ></b-img>
              </b-col>
              <b-col lg="10" md="10" sm="10" class="mobInfo">
                <span class="infoBlock">
                  <p class="topOomName">
                    {{ currentOomList[0].name }}
                  </p>
                  <p class="topOomName oomValue">
                    {{ currentOomList[0].oom_value }}
                  </p>
                  <p class="tournsPlayed">
                    <span>Tournaments: </span
                    >{{ currentOomList[0].tournaments_played }}
                  </p>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <template>
        <b-col class="mobCol" cols="12" sm="12">
          <div class="dataTitle">{{ rookieTitle }}</div>
          <a
            class="playertopSizes"
            :href="'/playerprofile/' + rookieFirst.playerno"
          >
            <b-img
              class="oomTopImg"
              :src="
                DEFIMAGESAMS3 + 'sst' + '/' + 'media/photos/' +
                rookieFirst.playerno +
                '.jpg'
              "
            ></b-img>
          </a>
          <b-row class="bottomOom">
            <b-col lg="12">
              <span class="homePos">
                <span class="innerPos">{{ rookieList[0].pos }}</span>
              </span>
            </b-col>
            <b-col lg="12">
              <b-row>
                <b-col lg="2" md="2" sm="2" class="mobFlag">
                  <b-img
                    class="playerFlag"
                    :src="
                      (config.VUE_APP_FLAG_URL + rookieList[0].nationality)
                        | lowercase
                    "
                  ></b-img>
                </b-col>
                <b-col lg="10" md="10" sm="10" class="mobInfo">
                  <span class="infoBlock">
                    <p class="topOomName">
                      {{ rookieList[0].name }}
                    </p>
                    <p class="topOomName oomValue">
                      {{ rookieList[0].oom_value }}
                    </p>
                    <p class="tournsPlayed">
                      <span>Tournaments: </span>{{ rookieList[0].tournaments_played }}
                    </p>
                  </span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </template>

      <b-col class="mobCol" cols="12" sm="12">
        <div class="dataTitle">{{ statsTitle }}</div>
        <a class="playertopSizes" :href="'/playerprofile/' + statsFirst.playerno">
          <b-img
            class="oomTopImg"
            :src="
              DEFIMAGESAMS3 + 'sst' + '/' + 'media/photos/' +
              statsFirst.playerno +
              '.jpg'
            "
          ></b-img>
        </a>
        <b-row class="bottomOom">
          <b-col lg="12">
            <span class="homePos">
              <span class="innerPos">{{ statsLists[0].pos }}</span>
            </span>
          </b-col>
          <b-col lg="12">
            <b-row>
              <b-col lg="2" md="2" sm="2" class="mobFlag">
                <b-img
                  class="playerFlag"
                  :src="
                    (config.VUE_APP_FLAG_URL + statsLists[0].nationality) | lowercase
                  "
                ></b-img>
              </b-col>
              <b-col lg="10" md="10" sm="10" class="mobInfo">
                <span class="infoBlock">
                  <p class="topOomName">
                    {{ statsLists[0].name }}
                  </p>
                  <p class="topOomName oomValue">
                    {{ statsLists[0].oom_value }}
                  </p>
                  <p class="tournsPlayed">
                    <span>Tournaments: </span>{{ statsLists[0].tournaments_played }}
                  </p>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HomeStats",
  props: ["season", "Year", "config", 'DEFIMAGESAMS3'],
  data() {
    return {
      menueLink: "menuLink",
      flag: "flag",
      currentOom: [],
      currentOomList:[],
      rookie: [],
      rookieList: [],
      stats: [],
      statsLists:[],
      // currentSeason: '224S'
      currentSeason: [],
      currentOomTitle: '',
      statsTitle: ''
    };
  },

  filters: {
    lowercase: function (value) {
      if (!value) {
        return "";
      }

      return value.toLowerCase() + ".svg";
    },
  },
  methods: {
    myGreeting:function () {
      console.log('SET STATS')
        this.statOne();
        this.statTwo();
        this.statThree();    
    },
    // YearSeason: function () {
    //   axios
    //   .get(
    //     "https://api.euro.ocs-software.com/sst/cache/sst" +
    //       "/tmticx?field=Y&fields=seasons&fields=tm_params.season_code&randomadd=" +
    //       new Date().getTime()
    //   )
    //   .then((response) => {
    //   this.currentSeason = response.data.tm_params.season_code;
    //   this.statOne();
    //   this.statTwo();
    //   this.statThree(); 
    //     console.log("this.currentSeason")
    //     console.log(this.currentSeason)
    //   });
    // },
    statOne: function () {
      axios
        .get(
          "https://api.euro.ocs-software.com/sst/cache/sst/" +
            this.Year +
            "/" +
            this.Year +
            "-stats-stats-Z4.json?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          const entries = response.data?.oom?.oom_entry || [];

          // directly filter (no temp array, no mutation loop)
          this.currentOomList = entries.filter(
            (value) => value.pos === "1"
          );

          this.currentOomTitle = response.data?.full_name || "";

          console.log("this.currentOomTitle", this.currentOomTitle);
        })
        .catch((error) => {
          console.error("statOne failed:", error);
          this.currentOomList = [];
          this.currentOomTitle = "";
        });
    },
    statTwo: function () {
      axios
        .get(
          "https://api.euro.ocs-software.com/sst/cache/sst/" +
            this.Year +
            "/" +
            this.Year +
            "-stats-stats-Z1.json?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          const entries = response.data?.oom?.oom_entry || [];

          this.rookieList = entries.filter(
            (value) => value.pos === "1"
          );

          this.rookieTitle = response.data?.full_name || "";
        })
        .catch((error) => {
          console.error("statTwo failed:", error);
          this.rookieList = [];
          this.rookieTitle = "";
        });
    },
    statThree: function () {
      axios
        .get(
          "https://api.euro.ocs-software.com/sst/cache/sst/" +
            this.Year +
            "/" +
            this.Year +
            "-stats-stats-ZA.json?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          const entries = response.data?.oom?.oom_entry || [];

          this.statsLists = entries.filter(
            (value) => value.pos === "1"
          );

          this.statsTitle = response.data?.full_name || "";
        })
        .catch((error) => {
          console.error("statThree failed:", error);
          this.statsLists = [];
          this.statsTitle = "";
        });
    }
  },
  computed: {
    currentOomFirst() {
      return this.currentOomList?.[0] || null;
    },
    rookieFirst() {
      return this.rookieList?.[0] || null;
    },
    statsFirst() {
      return this.statsLists?.[0] || null;
    }
  },
  // mounted() {
  //   this.YearSeason(),
  //   axios
  //     .get(
  //       "https://api.euro.ocs-software.com/sst/cache/sst/" +
  //         this.currentSeason +
  //         "/" +
  //         this.currentSeason +
  //         "-stats-stats-" +
  //         "ZA" + ".json?randomadd=" + new Date().getTime()
  //     )
  //     .then((response) => {
  //       this.currentOom = response.data.oom.oom_entry;
  //       this.currentOomTitle = response.data.full_name;
  //       return axios.get(
  //         "https://api.euro.ocs-software.com/sst/cache/sst/" +
  //           this.seasons +
  //           "/" +
  //           this.seasons +
  //           "-stats-stats-" +
  //           "ZE" + ".json?randomadd=" + new Date().getTime()
  //       );
  //     })
  //     .then((response) => {
  //       this.rookie = response.data.oom.oom_entry;
  //       this.rookieTitle = response.data.full_name;
  //       return axios.get(
  //         "https://api.euro.ocs-software.com/sst/cache/sst/" +
  //           this.seasons +
  //           "/" +
  //           this.seasons +
  //           "-stats-stats-" +
  //           "Z1" + ".json?randomadd=" + new Date().getTime()
  //       );
  //     })
  //     .then((response) => {
  //       this.stats = response.data.oom.oom_entry;
  //       this.statsTitle = response.data.full_name;
  //     });
  // },
  mounted() {
    // this.YearSeason();
      this.myTimeout = setTimeout(this.myGreeting, 5000);
  },
};
</script>

<style scoped>
.dataTitle {
  color: #fff;
  background: #f2af15!important;
  padding: 5px;
  font-weight: bold;
  font-size: 15px;
  border-radius: 10px 10px 0px 0px;
  padding-left: 15px;
  height: 40px;
  padding-top: 8px;
}
.infoBlock:hover {
  padding-top: 20px;
  padding-bottom: 50px;
  display: block;
  padding-left: 20px;
  text-decoration: underline;
  color: #fff;
}
.playerLink:hover > .bottomOom {
}
.sponsorImage {
  width: 100%;
}
.infoBlock {
  padding-top: 20px;
  /* padding-bottom: 30px; */
  padding-bottom: 50px;
  display: block;
  padding-left: 20px;
}
.tournsPlayed {
  font-size: 14px;
  color: #ffffff;
  font-weight: 100;
  margin-bottom: 0 !important;
  padding-right: 20px;
}
.oomValue {
  color: #f2af14 !important;
  font-size: 14px;
}
span.innerPos {
  margin-top: 10px;
  display: inline-block;
  font-size: 21px;
}
.oomTopImg {
  /* border-radius: 10px 10px 0 0; */
  /* width: 100%; */
  width: 100%;
  max-height: 210px;
  min-width: 350px;
  max-width: 350px;
}
.bottomOom {
  background-color: #006837;
  border-radius: 0 0 0px 0px;
  margin-left: 0;
  margin-right: 0;
  padding-top: 10px;
  margin-bottom: 15px;
}
.homePos {
  color: #fff;
  font-weight: 700;
  text-align: center;
  margin: auto;
  display: block;
  background: #f2af15;
  width: 50px;
  border-radius: 40px;
  height: 50px;
  margin-top: -40px;
}
.topOom {
  float: right;
  display: -webkit-box;
}
.topOomName {
  margin-bottom: 0 !important;
  padding-right: 20px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}
.playerFlag {
  width: 35px;
  height: 35px;
  background: black;
  border-radius: 30px;
  margin-top: 32px;
  margin-left: 20px;
}
::v-deep .col:nth-child(2) {
  /* transform: scale(1.13); */
  z-index: 99;
  /* margin-top: -14px;  */
}
@media only screen and (max-width: 1199px ) and ( min-width: 990px) {
  .oomTopImg {
    /* border-radius: 10px 10px 0 0; */
    width: 100%;
    max-height: 174px !important;
    min-width: auto;
    max-width: auto;
  }
}
@media only screen and (min-width: 991px) {
  .Mob {
    display: none;
  }
}
@media only screen and (max-width: 990px) {
  ::v-deep .oomTopImg {
    max-height: initial;
    width: 100%;
    min-width: auto!important;
    max-width: revert;
  }
  ::v-deep .mobCol {
    width: 100%;
    display: block;
  }
  .bottomOom {
    width: 100%;
  }
  .Desk {
    display: none;
  }
  .tThree {
    padding: 30px 0;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
@media only screen and (max-width: 768px) {
  .oomTopImg {
    width: 100%;
  }
  .infoBlock {
    padding-top: 20px;
    padding-bottom: 30px;
    display: block;
    padding-left: 20px;
    text-align: left;
  }
  .btn-group {
    width: 100%;
    margin-bottom: 15px;
  }
  .topThree {
    padding: 15px;
    margin: auto;
    text-align: center;
  }
  .row.Mob {
    display: -webkit-inline-box;
    overflow: scroll;
    overflow-x: auto;
    white-space: nowrap;
    width: 100%;
  }
  .mobCol {
    /* width: 100%; */
    width: 350px;
    display: block;
    overflow-x: auto;
    /* white-space: nowrap; */
    /* display: block; */
    float: none;
    display: inline-block;
  }
}

@media only screen and (max-width: 500px) {
  .mobFlag {
    width: 20%;
  }
  .mobInfo {
    width: 80%;
  }
}
</style>